import {
  __name
} from "../chunk-7QVYU63E.js";
var ActorResourceArn = /* @__PURE__ */ function(ActorResourceArn2) {
  ActorResourceArn2["User"] = "alchemy:user";
  ActorResourceArn2["ExternalService"] = "alchemy:external_service";
  ActorResourceArn2["InternalService"] = "alchemy:internal_service";
  return ActorResourceArn2;
}({});
const ACTOR_RESOURCE_ARN_VALUES = Object.values(ActorResourceArn);
function stringifyActorId(actorId) {
  return `${actorId.resourceArn}:${actorId.id}`;
}
__name(stringifyActorId, "stringifyActorId");
function parseActorId(actorId) {
  const parts = actorId.split(":");
  if (parts.length < 3) {
    throw new Error("Invalid actor ID");
  }
  const id = parts.pop();
  const resourceArn = parts.join(":");
  if (!resourceArn || !id) {
    throw new Error("Invalid actor ID");
  }
  if (!ACTOR_RESOURCE_ARN_VALUES.includes(resourceArn)) {
    throw new Error("Invalid actor resource ARN");
  }
  return {
    id,
    resourceArn
  };
}
__name(parseActorId, "parseActorId");
export {
  ActorResourceArn,
  parseActorId,
  stringifyActorId
};
//# sourceMappingURL=actorId.js.map